import { freddyTheme, type SxProps } from '@coolblue-development/freddy';

export const highlightedAlternativeProductCardStyles: SxProps = {
  display: 'contents',

  label: {
    '& p': {
      gridRow: '1'
    },

    gap: '0',
    gridTemplateRows: 'subgrid',
    gridColumn: 'span 12',
    gridRow: 'span 3',
    [freddyTheme.breakpoint.minWidth('md')]: {
      gridColumn: 'span 4'
    }
  }
};

export const alternativeProductCardStyles: SxProps = {
  display: 'contents',

  label: {
    '& p': {
      gridRow: '1'
    },

    gap: '0',
    gridTemplateRows: 'subgrid',
    gridColumn: 'span 12',
    gridRow: 'span 2',
    [freddyTheme.breakpoint.minWidth('md')]: {
      gridColumn: 'span 4'
    }
  }
};

export const trackingContainerStyles: SxProps = {
  display: 'contents',

  '> div': {
    display: 'contents'
  }
};
